import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton, mobileOrderButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/wTOt0S1LwH0wZVL5nbMw/locations/IuRLFYm0Xl6J7IPT6Fmf`}
            >
              <CFView hover>
                <CFImage
                  src={mobileOrderButton}
                  w="100%"
                  minWidth="300px"
                  alt="About"
                />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/wTOt0S1LwH0wZVL5nbMw/locations/IuRLFYm0Xl6J7IPT6Fmf`}
            >
              <CFView hover>
                <CFImage src={orderPickupButton} maxWidth="300px" alt="About" />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
